import React from "react";
import { useState } from "react";
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer,Typography } from "@mui/material";
import style from "./style";
import CustomPagination from "../../../../../components/CustomPagination";
import { formatDate } from "../../../../../utils/DateFormat";
// import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
// import { useAlert } from "../../../../context/AlertContext";


const StatementGenarateList = ({data,page,success,setPage,total,}) => {

  
  const [rowsPerPage, setRowsPerPage] = useState(10);
  
  return (
    <>

           
      <TableContainer  sx={style.noShadow}>
        <Table  >
          <TableHead>
            <TableRow>
              <TableCell sx={style.tableHead}>Date</TableCell>
              <TableCell sx={style.tableHead}>Amount</TableCell>
              <TableCell sx={style.tableHead}>Description</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {(!data || !success) ? ( 
              <TableRow>
                <TableCell colSpan={6} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : ( 
              data?.transactions?.map((item, index) => (
                <TableRow key={index} sx={{verticalAlign:"baseline"}}>
                  <TableCell sx={style.tabledata}>{formatDate(item?.date)}</TableCell>
                  <TableCell sx={style.tabledata}>{item?.amount.toFixed(2)}</TableCell>
                  <TableCell sx={style.tabledata}>{item?.desc}</TableCell>

                </TableRow>
              ))
            )}
          </TableBody>

        </Table>
        {data &&
         <CustomPagination
           pageCount={total}         
           page={page}
           setPage={setPage}
           rowsPerPage={rowsPerPage}
           setRowsPerPage={setRowsPerPage}
           totalItems={data.length}
         />} 

      </TableContainer>


    </>
  );
};
export default StatementGenarateList;
